import React from 'react';

export function CapacityBar({ value = 0, color = 'var(--green)', label, right }) {
  const pct = Math.max(0, Math.min(100, Number(value || 0)));
  return (
    <div className="capacity-row">
      {(label || right) ? (
        <div className="capacity-row-head">
          <span>{label}</span>
          <span>{right}</span>
        </div>
      ) : null}
      <div className="slot-capacity-track">
        <div className="slot-capacity-fill" style={{ width: `${pct}%`, background: color }} />
      </div>
    </div>
  );
}

export function SegmentedCapacityBar({ segments = [], label, right }) {
  const total = segments.reduce((sum, item) => sum + Number(item.value || 0), 0) || 1;
  return (
    <div className="capacity-row">
      {(label || right) ? (
        <div className="capacity-row-head">
          <span>{label}</span>
          <span>{right}</span>
        </div>
      ) : null}
      <div className="slot-capacity-track">
        <div className="slot-capacity-segmented">
          {segments.map(segment => (
            <div
              key={segment.key || segment.label}
              className="slot-capacity-segment"
              title={segment.label}
              style={{
                width: `${Math.max(0, Number(segment.value || 0) / total * 100)}%`,
                background: segment.color || 'var(--green)'
              }}
            />
          ))}
        </div>
      </div>
      {segments.length ? (
        <div className="capacity-legend">
          {segments.map(segment => (
            <span key={segment.key || segment.label}>
              <span className="capacity-dot" style={{ background: segment.color || 'var(--green)' }} />
              {segment.label}
            </span>
          ))}
        </div>
      ) : null}
    </div>
  );
}
